import { trackLink, trackView } from "~/helpers/trackings";
import { formatValueTrackings, parseCartForTrack } from "./helpers";
import { STORE_CODE } from "./constants";

export const productView = async (product) => {
    const { attributeSetName, name } = product || {};

    trackView({
        page_name: `${STORE_CODE}:${formatValueTrackings(attributeSetName)}:${formatValueTrackings(name)}`,
        page_category_1: STORE_CODE,
        page_category_2: formatValueTrackings(attributeSetName),
        page_category_3: formatValueTrackings(name),
        page_category_10: 'dettaglio-prodotto',
        page_content_status: 'free' 
    });
}

export const productLinkTrack = async (product) => {
    const { sku, name, attributeSetName } = product || {};

    trackLink({
        event_name: `product_view`,
        product_id: `${formatValueTrackings(sku)}`,
        product_name: `${formatValueTrackings(name)}`,
        product_category: `${formatValueTrackings(attributeSetName)}`
    }, null, `PLT @VIEW-LINK: ${formatValueTrackings(name)}`)
}


export const productBuyCTATrack = async (product) => {
    const { name } = product || {};

    trackLink({
        event_name: `${STORE_CODE}:${formatValueTrackings(name)}:abbonati`,
        event_type: `abbonati`
    }, null, `PBCTA @CLICK: ${STORE_CODE}:${formatValueTrackings(name)}:abbonati`)
}


export const productFreeCTATrack = async (product) => {
    const { name } = product || {};

    trackLink({
        event_name: `${STORE_CODE}:${formatValueTrackings(name)}:prova-gratuitamente`,
        event_type: `prova-gratuitamente`
    }, null, `PBCTA @CLICK: ${STORE_CODE}:${formatValueTrackings(name)}:prova-gratuitamente`)
}


export const productUpSellLinkTrack = async (product, callback) => {
    const { name, attributeSetName } = product || {};

    trackLink({
        event_name: `${STORE_CODE}:${formatValueTrackings(name)}:altri-prodotti`,
        event_type: `${attributeSetName}:${name}`
    }, callback, `PUSLT @CLICK: ${STORE_CODE}:${formatValueTrackings(name)}:altri-prodotti`)
}

export const productUpSellNavTrack = async (product, val) => {
    const { name } = product || {};

    trackLink({
        event_name: `${STORE_CODE}:${formatValueTrackings(name)}:navigazione`,
        event_type: `${formatValueTrackings(val)}`
    }, null, `PUSNT @CLICK: ${formatValueTrackings(val)}`)
}

export const productContactTrack = async (product, callback) => {
    const { name } = product || {};

    trackLink({
        event_name: `${STORE_CODE}:${formatValueTrackings(name)}:contattaci`,
        event_type: `contattaci`
    }, callback, `PCT @CLICK: ${formatValueTrackings(name)}`)
}

export const productGoToSiteTrack = async (product, callback) => {
    const { name } = product || {};

    trackLink({
        event_name: `${STORE_CODE}:${formatValueTrackings(name)}:vai-al-sito`,
        event_type: `vai-al-sito`
    }, callback, `PGTS @CLICK: ${formatValueTrackings(name)}`)
}

export const productTutorialTrack = async (product, tutorialName) => {
    const { name } = product || {};

    trackLink({
        event_name: `${STORE_CODE}:${formatValueTrackings(name)}:sfrutta-tutte-le-potenzialità`,
        event_type: `${tutorialName}`
    }, null, `PTT @CLICK: ${formatValueTrackings(name)}`)
}

export const productCompareTrack = async (product) => {
    const { name } = product || {};

    trackLink({
        event_name: `${STORE_CODE}:${formatValueTrackings(name)}:compara-le-funzionalità`,
        event_type: `compara-le-funzionalità`
    }, null, `PCT @CLICK: ${formatValueTrackings(name)}`)
}

export const productConfigureTrack = async (moduleList) => {
    const formattedModules = moduleList.map(module => formatValueTrackings(module)).join(':');

    trackLink({
        event_name: `${STORE_CODE}:${formattedModules}:configurazione-prodotto`,
        event_type: `procedi`
    }, null, `PCT @CLICK: ${formattedModules}`)
}

export const productUpgradeTrack = async (product) => {
    const { name } = product || {};

    trackLink({
        event_name: `${STORE_CODE}:${formatValueTrackings(name)}:configurazione-prodotto`,
        event_type: `passa-a-premium`
    }, null, `PUT @CLICK: ${formatValueTrackings(name)}`)
}

export const productPeriodicityToggleTrack = async (product, periodicity) => {
    const { name } = product || {};

    trackLink({
        event_name: `${STORE_CODE}:${formatValueTrackings(name)}:toggle-abbonamento`,
        event_type: `${formatValueTrackings(periodicity)}`
    }, null, `PPT @CLICK: ${STORE_CODE}:${formatValueTrackings(name)}:toggle-abbonamento:${periodicity}`)
}

export const productAddToCartTrack = async (cart, item, categoryName = "", label, redirect) => {
    const { sku, name, quantity, price } = parseCartForTrack(cart, item);
    const eventName = redirect ? 'configurazione-prodotto' : 'add-to-cart';

    const trackingPayload = {
        event_name: `${STORE_CODE}:${formatValueTrackings(name)}:${eventName}`,
        event_type: `${formatValueTrackings(label)}`,
        product_id: `${formatValueTrackings(sku)}`,
        product_name: `${formatValueTrackings(name)}`,
        product_category: `${formatValueTrackings(categoryName)}`,
        product_price: `${price}`,
        product_quantity: `${quantity}`,
    };

    trackLink(trackingPayload, null, `PATCT @CLICK: ${JSON.stringify(trackingPayload)}`)
}